import React from "react";
import {FormattedMessage} from "react-intl";
import RadioButtonGroup from "../../RadioButtonGroup/RadioButtonGroup";
import {Link} from "react-router-dom";
import DesignImage from "../../../../../assets/img/differentDesign.jpg";
import '../../../QuotationForm/PCBQuotationForm/PCBQuotationFormFields/DifferentDesign.css'
import InitialAdminState from "../../../../Admin/AdminRoot/InitialAdminState";

let differentDesign = [
    {id: 1, checked: true, text: 1, name: "differentDesign"},
    {id: 2, checked: false, text: 2, name: "differentDesign"},
    {id: 3, checked: false, text: 3, name: "differentDesign"},
    {id: 4, checked: false, text: 4, name: "differentDesign"},
    {id: 5, checked: false, text: 5, name: "differentDesign"},
    {id: 6, checked: false, text: 6, name: "differentDesign"}
];


const DifferentDesign = (props) => {

    let pcbDifferentDesign = differentDesign.map((item) => {
        item.checked = (item.id === props.selectedId);
        return item;
    });
    let designValue = props.selectedId;


    return (
        <div className="row">
            <div className="col-md-12 no-padding">
                <div className="pcb-details-div">
                    <div className="col-md-3 text-right content-item-heading">
                        <FormattedMessage id="app.pcb-quotation.pcb-different-design"
                                          defaultMessage="Different Design"
                                          description=""
                        />
                        &nbsp; &nbsp;
                        <Link id="different-qLink"
                            to={{pathname:"https://kitcutlabo.com/different-design-board/"}} target="_self"
                            className="glyphicon glyphicon-question-sign question-link"></Link>
                    </div>
                    <div className="btn-group col-md-9 pcb-details-div-items">
                        <div className="col-md-8 different-div">
                            <span className="inlign-block-btn-group"><RadioButtonGroup data={pcbDifferentDesign}
                                                                                       getParams={props.setPCBParams}/></span>
                            {
                                InitialAdminState.radioBtnClick === true ?
                                    <input type="text" value="" name="differentDesign"
                                           onChange={props.setDifferentDesign} className="form-control input-btn-value"
                                           aria-label="Username"
                                           aria-describedby="addon-wrapping" max={50}/>
                                    :
                                    <input type="text" value={designValue} name="differentDesign"
                                           onChange={props.setDifferentDesign} className="form-control input-btn-value"
                                           aria-label="Username"
                                           aria-describedby="addon-wrapping" max={50}/>
                            }
                            {/*<input  type="text" value={designValue} name = "differentDesign" onChange={props.setDifferentDesign} className="form-control input-btn-value" aria-label="Username"*/}
                            {/*aria-describedby="addon-wrapping"/>*/}
                            <p className="pcb-details-div-clr-caption adjust-margin">
                                ※異なる複数の基板にてシート構成されている場合は、異種面付仕様となります。
                            </p>
                            <p className="pcb-details-div-clr-caption adjust-margin">
                                ፠ Vカットによる面付け方法の場合、基板サイズは70mm×70mm以上必要です。
                            </p>
                        </div>
                        <div className="col-md-4 different-link">
                            <a>
<span className="quotation-link-text-color">
       <FormattedMessage id="app.pcb-quotation.pcb-different-design-caption"
                         defaultMessage="For example"
                         description=""/>
</span>
                             <span className="spaceSpan">  </span>
                                <link id="pcbstnclSide-qLink" to=""
                                      className="glyphicon glyphicon-question-sign question-link"></link>

                                <div className="img-responsive ex-img"><img alt="image" src={DesignImage}
                                                                            width="450px"/></div>

                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default DifferentDesign;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/DifferentDesign.js